import {
  ShoppingCartOutlined,
  ProjectOutlined,
  ToolOutlined,
  FileSearchOutlined,
  DashboardOutlined,
  RobotOutlined,
  DatabaseOutlined,
  CustomerServiceOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

export type ModuleStatus = "active" | "coming-soon";

export interface ModuleConfig {
  id: string;
  /** Display name on the launcher card. */
  name: string;
  description: string;
  icon: any;
  iconColor: string;
  bgGradient: string;
  /** Same-origin path on the unified domain. */
  path: string;
  /**
   * Must match the `appType` returned by
   * GET /users/getUserAccessibleModules — used to filter the launcher.
   * Compared case-insensitively.
   */
  appType: string;
  status: ModuleStatus;
}

/**
 * Single source of truth for the module launcher.
 * Icons + colors mirror prx_buyerapp-ui/src/layout/header/ApplicationApps.
 */
export const modules: ModuleConfig[] = [
  {
    id: "p2p",
    name: "Procure to Pay",
    description: "End-to-end procurement, orders, invoices and payments",
    icon: ShoppingCartOutlined,
    iconColor: "#2563eb",
    bgGradient: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
    // `/p2p` itself is the buyer app's own login route (`<Route index>` there
    // renders <Login/>). The shell user is already authenticated via the shared
    // cookie, so land on the authenticated dashboard instead.
    path: "/p2p/home",
    appType: "Procurement",
    status: "active",
  },
  {
    id: "pms",
    name: "Project Management",
    description: "Plan and track projects efficiently",
    icon: ProjectOutlined,
    iconColor: "#7c3aed",
    bgGradient: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)",
    path: "/pms",
    appType: "PMS",
    status: "active",
  },
  {
    id: "wom",
    name: "Work Order Management",
    description: "Manage work orders seamlessly",
    icon: ToolOutlined,
    iconColor: "#f59e0b",
    bgGradient: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
    path: "/wom",
    appType: "Work order",
    status: "active",
  },
  {
    id: "tms",
    name: "Tender Management",
    description: "Handle tenders and bids",
    icon: FileSearchOutlined,
    iconColor: "#06b6d4",
    bgGradient: "linear-gradient(135deg, #cffafe 0%, #a5f3fc 100%)",
    path: "/tms",
    appType: "Tender",
    status: "active",
  },
  {
    id: "control-tower",
    name: "Control Tower",
    description: "Monitor and control operations",
    icon: DashboardOutlined,
    iconColor: "#10b981",
    bgGradient: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
    path: "/control-tower",
    appType: "Control Tower",
    status: "active",
  },
  {
    id: "controlx",
    name: "Control X",
    description: "AI-powered assistant for automation",
    icon: RobotOutlined,
    iconColor: "#8b5cf6",
    bgGradient: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)",
    path: "/controlx",
    appType: "Control X",
    status: "active",
  },
  {
    id: "auction",
    name: "Auction",
    description: "Participate in auctions and bidding",
    icon: TrophyOutlined,
    iconColor: "#f97316",
    bgGradient: "linear-gradient(135deg, #fed7aa 0%, #fdba74 100%)",
    path: "/auction",
    appType: "Auction",
    status: "active",
  },
  {
    id: "masters",
    name: "Masters",
    description: "Manage organisation, users, roles and master data",
    icon: DatabaseOutlined,
    iconColor: "#475569",
    bgGradient: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
    path: "/masters",
    appType: "Master",
    status: "active",
  },
  {
    id: "crm",
    name: "CRM",
    description: "Customer relationship management",
    icon: CustomerServiceOutlined,
    iconColor: "#ec4899",
    bgGradient: "linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)",
    path: "/crm",
    appType: "CRM",
    status: "active",
  },
];
